import { render, staticRenderFns } from "./VlMobileFilterTransition.vue?vue&type=template&id=c161edde&scoped=true&"
import script from "./VlMobileFilterTransition.vue?vue&type=script&lang=js&"
export * from "./VlMobileFilterTransition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c161edde",
  null
  
)

export default component.exports